import React from 'react';

export default () => (
  <div className="accordion-footer">
    <p className="error-message">Before submiting module, add response to all quEstions</p>
    <div className="btn bordered empty grey-empty">SUBMIT MODULE</div>
  </div>
);



// WEBPACK FOOTER //
// ./src/blocks/accordion/AccordionFooter.jsx